import { faPlus as AddIcon } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';
import { useLocation, useNavigate } from 'react-router';

import { ticketDialogIsOpenAtom } from '@/pages/Ticket';
import { isLayoutMobileAtom } from '@/store/layout';
import { userIsInternalAtom } from '@/store/user.store';

const CreateTicketButton = () => {
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [, setTicketDialogIsOpen] = useAtom(ticketDialogIsOpenAtom);
  const [userIsInternal] = useAtom(userIsInternalAtom);
  const location = useLocation();
  const navigate = useNavigate();
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'ticketMenu'
  });

  const handleSelection = (selection: string) => {
    popupState.close();
    if (selection === 'Service Ticket') {
      setTicketDialogIsOpen(true);
      return;
    }

    navigate('/ticket/create', { state: location.pathname });
  };

  return (
    <>
      <Button
        color="warning"
        size="small"
        variant="outlined"
        onClick={() => {
          return !userIsInternal ? setTicketDialogIsOpen(true) : null;
        }}
        {...(!isLayoutMobile && {
          startIcon: <FontAwesomeIcon icon={AddIcon} />
        })}
        {...(userIsInternal && bindTrigger(popupState))}
      >
        {isLayoutMobile && <FontAwesomeIcon icon={AddIcon} />}
        {!isLayoutMobile && 'Create Ticket'}
      </Button>
      <Menu {...bindMenu(popupState)}>
        <MenuItem onClick={() => handleSelection('Service Ticket')}>
          <Typography variant="subtitle2">Service Ticket</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleSelection('Threat Ticket')}>
          <Typography variant="subtitle2">Threat Ticket</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default CreateTicketButton;
